// Copyright 2025 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { LicenseBundle, LicenseKind } from "datatypes/SoramaWebApi";
import { IAuthentication, IAuthenticationHandler } from "libraries/Authentication/IAuthentication";
import { LicenseBundleRepository } from "repositories/LicenseBundleRepository";
import { LicenseHolderRepository } from "repositories/LicenseHolderRepository";
import { PackageFileInfo } from "services/Hardware/CamHTTP/ICamApi";
import { ILicenseBundleService } from "./ILicenseBundleService";

@autoinject
export class LicenseBundleService implements ILicenseBundleService, IAuthenticationHandler {
    constructor(
        private readonly licenseHolderRepository: LicenseHolderRepository,
        private readonly licenseBundleRepository: LicenseBundleRepository,
        private readonly authentication: IAuthentication
    ) {
        this.authentication.addAuthenticationHandler(this);
    }

    public onSignIn(userId: string): Promise<void> {
        return Promise.resolve();
    }

    public onSignOut(): Promise<void> {
        return Promise.resolve();
    }

    public async getOwnedLicenseBundlesForDevice(deviceId: string): Promise<LicenseBundle[]> {
        const ownedLicenseBundles = await this.licenseBundleRepository.getOwnedLicenseBundles(
            this.authentication.businessUnitId,
            deviceId
        );
        return ownedLicenseBundles;
    }

    public async getActiveBundlesLicenseKinds(deviceId?: string): Promise<LicenseKind[]> {
        const licenseKinds = await this.licenseBundleRepository.getActiveBundlesLicenseKinds(
            this.authentication.businessUnitId,
            deviceId
        );
        return licenseKinds;
    }

    public async getSignedLicenseBundle(bundleId: string, hardwareClock: number): Promise<string> {
        return this.licenseBundleRepository.getSignedLicenseBundle(bundleId, hardwareClock);
    }

    public async getPackageFile(deviceId: string): Promise<PackageFileInfo> {
        return this.licenseBundleRepository.getPackageFile(deviceId);
    }
}
